//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  props: {
    items: {
      type: Array,
      default: () => {
        return []
      }
    }
  },

  computed: {
    isVisible: function () {
      return (this.items && this.items.length > 0)
    }
  },

  methods: {
    _getName: function (name) {
      return [this.$t('blog.getNumberFor'), String(name || '')].filter((t) => !!t).join(' ')
    },
  }
}
